import { render, staticRenderFns } from "./AboutBi.vue?vue&type=template&id=3896ba73&scoped=true&"
import script from "./AboutBi.vue?vue&type=script&lang=js&"
export * from "./AboutBi.vue?vue&type=script&lang=js&"
import style0 from "./AboutBi.vue?vue&type=style&index=0&id=3896ba73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896ba73",
  null
  
)

export default component.exports